const logs = [
  {
    path: 'logs',
    name: 'activities',
    icon: 'cil-list-high-priority',
    showInMenu: true,
    components: {
      content: () => import('@/views/pages/logs/List.vue')
    },
    meta: {
      requiredRole: ['admin'],
      moduleSlug: 'activities'
    }
  }
]

export default logs
